(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    

class StickyHeader extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.header = document.querySelector('.section-header');
    this.headerIsAlwaysSticky =
      this.getAttribute('data-sticky-type') === 'always' ||
      this.getAttribute('data-sticky-type') === 'reduce-logo-size';

    this.headerBounds = {};
    this.currentScrollTop = 0;
    this.preventReveal = false;

    this.setHeaderHeight();

    window.matchMedia('(max-width: 990px)')
      .addEventListener('change', this.setHeaderHeight.bind(this));

    if (this.headerIsAlwaysSticky) {
      this.header.classList.add('shopify-section-header-sticky');
    }

    this.onScrollHandler = this.onScroll.bind(this);
    window.addEventListener('scroll', this.onScrollHandler, false);

    this.createObserver();
  }

  setHeaderHeight() {
    const height = this.header.offsetHeight;
    document.documentElement.style.setProperty('--pf-header-height', height + 'px');
  }

  disconnectedCallback() {
    window.removeEventListener('scroll', this.onScrollHandler);
  }

  createObserver() {
    const observer = new IntersectionObserver((entries) => {
      this.headerBounds = entries[0].intersectionRect;
      observer.disconnect();
    });

    observer.observe(this.header);
  }

  onScroll() {
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

    if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
      this.hide();
    } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
      this.reveal();
    } else if (scrollTop <= this.headerBounds.top) {
      this.reset();
    }

    this.currentScrollTop = scrollTop;
  }

  hide() {
    if (this.headerIsAlwaysSticky) return;
    this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
  }

  reveal() {
    if (this.headerIsAlwaysSticky) return;
    this.header.classList.add('shopify-section-header-sticky', 'animate');
    this.header.classList.remove('shopify-section-header-hidden');
  }

  reset() {
    if (this.headerIsAlwaysSticky) return;
    this.header.classList.remove(
      'shopify-section-header-hidden',
      'shopify-section-header-sticky',
      'animate'
    );
  }
}


customElements.define('sticky-header', StickyHeader);

function syncPfMenuWithHeader() {
  const header = document.querySelector('.section-header');
  if (!header) return;

  const height = header.getBoundingClientRect().height;
  document.documentElement.style.setProperty(
    '--pf-header-height',
    height + 'px'
  );
}

syncPfMenuWithHeader();
window.addEventListener('resize', syncPfMenuWithHeader);
window.addEventListener('scroll', syncPfMenuWithHeader);


// FIXED: Proper menu toggle functionality
document.addEventListener("DOMContentLoaded", function () {
  const menu = document.getElementById("pf-menu");
  const overlay = document.getElementById("pf-overlay");
  const menuBtn = document.getElementById("pf-menu-btn");

  if (!menu || !overlay || !menuBtn) return;

  function openMenu() {
    menu.classList.add("active");
    overlay.classList.add("active");
    document.body.classList.add("pf-menu-open");
    menuBtn.classList.add("active");
    menuBtn.setAttribute("aria-expanded", "true");
    menu.setAttribute("aria-hidden", "false");
  }

  function closeMenu() {
    menu.classList.remove("active");
    overlay.classList.remove("active");
    document.body.classList.remove("pf-menu-open");
    menuBtn.classList.remove("active");
    menuBtn.setAttribute("aria-expanded", "false");
    menu.setAttribute("aria-hidden", "true");
  }

  // Toggle menu on button click
  menuBtn.addEventListener("click", function (e) {
    e.stopPropagation();
    menu.classList.contains("active") ? closeMenu() : openMenu();
  });

  // Close menu on overlay click
  overlay.addEventListener("click", closeMenu);
  
  // Close menu on ESC key
  document.addEventListener("keydown", function(e) {
    if (e.key === "Escape" && menu.classList.contains("active")) {
      closeMenu();
    }
  });
});


// Accordion functionality
document.querySelectorAll(".pf-accordion-toggle").forEach(toggle => {
  toggle.addEventListener("click", () => {
    const expanded = toggle.getAttribute("aria-expanded") === "true";
    const content = toggle.closest(".pf-accordion").querySelector(".pf-accordion-content");

    toggle.setAttribute("aria-expanded", !expanded);

    if (!expanded) {
      content.style.maxHeight = content.scrollHeight + "px";
    } else {
      content.style.maxHeight = null;
    }
  });
});

document.addEventListener("DOMContentLoaded", function () {
  document.querySelectorAll('.pf-menu-link').forEach(link => {
    link.addEventListener('click', function () {
      const menu = document.getElementById("pf-menu");
      const overlay = document.getElementById("pf-overlay");
      const menuBtn = document.getElementById("pf-menu-btn");

      if (!menu || !overlay || !menuBtn) return;

      menu.classList.remove("active");
      overlay.classList.remove("active");
      document.body.classList.remove("pf-menu-open");

      menuBtn.classList.remove("active");
      menuBtn.setAttribute("aria-expanded", "false");
      menu.setAttribute("aria-hidden", "true");
    });
  });
});

// ================================
// 🌟 IMPROVED PRODUCT SEARCH
// ================================
document.addEventListener("DOMContentLoaded", () => {
  const input = document.querySelector('.predictive-search__input');
  const results = document.querySelector('.predictive-search__results');

  if (!input || !results) return;

  let controller;

  input.addEventListener("input", async (e) => {
    const query = e.target.value.trim();
    if (query.length < 2) {
      results.innerHTML = '';
      return;
    }

    controller?.abort();
    controller = new AbortController();

    try {
      const res = await fetch(
        `/search/suggest.json?q=${encodeURIComponent(query)}&resources[type]=product&resources[limit]=10`,
        { signal: controller.signal }
      );
      const data = await res.json();
      renderProductResults(data, query);
    } catch (_) {}
  });

  function renderProductResults(data, query) {
    const products = data.resources.results.products || [];

    let html = '';

    if (products.length) {
      html += `<div class="predictive-search__products-grid">`;
      
      products.forEach(p => {
        const imageUrl = p.image ? p.image : '';
        const price = p.price ? (p.price / 100).toFixed(2) : '';
        
        html += `
          <a class="predictive-search__product-item" href="${p.url}">
            ${imageUrl ? `<img src="${imageUrl}" alt="${p.title}" class="predictive-search__product-image" loading="lazy">` : ''}
            <div class="predictive-search__product-info">
              <span class="predictive-search__product-title">
                ${highlight(p.title, query)}
              </span>
              ${price ? `<span class="predictive-search__product-price">₹${price}</span>` : ''}
            </div>
          </a>
        `;
      });
      
      html += `</div>`;
    } else {
      html = `<div class="predictive-search__no-results">No products found for "${query}"</div>`;
    }

    results.innerHTML = html;
  }

  function highlight(text, q) {
    return text.replace(
      new RegExp(`(${q})`, 'ig'),
      '<strong>$1</strong>'
    );
  }
});

document.addEventListener("click", (e) => {
  if (e.target.closest('.header__icon--search')) {
    document.body.classList.add('search-open');
  }

  if (e.target.closest('.search-modal__close-button')) {
    document.body.classList.remove('search-open');
  }
});




  } catch(e) { console.error(e); }
})();
})();
